import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingAction } from '../../../shared/models/loading-action.enum';
import { LoadingService } from '../../../shared/services/loading.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomerStoreService } from '../../../core/services/customer-store.service';
import { HandsetService } from '../../../core/services/handset.service';
import { ToolbarService } from '../../../core/services/toolbar.service';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
standalone: false,
  selector: 'app-add-liability-email',
  templateUrl: './add-liability-email.component.html',
  styleUrls: ['./add-liability-email.component.scss'],
  animations: [
    trigger('iconAnimation', [
      state('false', style({
        opacity: 1,
        transform: 'scale(1)',
      })),
      state('true', style({
        opacity: 1,
        transform: 'scale(1)',
      })),
      transition('false <=> true', [
        animate('300ms ease-in-out', style({
          transform: 'scale(1.1)',
        })),
        animate('500ms 300ms ease-in-out', style({
          transform: 'scale(1)',
        })),
      ]),
    ]),
  ],
})
export class AddLiabilityEmailComponent implements OnInit, OnDestroy {
  @Input() public submit: Observable<void>;
  public copied = false;
  public inboxEmailAddress: string;
  public loadingAction = LoadingAction;
  private timeoutId: any;

  constructor(
    public loadingService: LoadingService,
    public handsetService: HandsetService,
    private customerStoreService: CustomerStoreService,
    private router: Router,
    private route: ActivatedRoute,
    private toolbar: ToolbarService,
    private snackbar: MatSnackBar,
  ) {
    this.toolbar.init(this.route);
  }

  ngOnInit(): void {
    this.getInboxEmailAddress().subscribe((data) => {
      this.inboxEmailAddress = data.inboxEmailAddress;
    });
  }

  ngOnDestroy(): void {
    this.clearTimeout();
  }

  clearTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  public onCopied(): void {
    this.copied = true;
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.copied = false;
      this.clearTimeout();
    }, 7000);
  }

  private getInboxEmailAddress(): Observable<any> {
    return this.customerStoreService.getInboxEmailAddress();
  }

  public goBack(): void {
    this.router.navigate(['/liabilities/add']);
  }

}
